<h2 mat-dialog-title>Grade team</h2>
<mat-dialog-content style="max-height: 100%; background-color: var(--mat-app-background-color);"   >    
    <app-game-header-small [Game]="game"></app-game-header-small>
    
    <!-- Debug info -->
    <div style="font-size: 10px; color: gray; padding: 5px; border: 1px solid #ccc; margin: 5px 0;">
        Debug: Team: {{team}} | Loaded {{playerGrades.size}} grades | Players: {{players.length}} | Loading: {{isLoadingGrades}}
    </div>
    
    @if (isLoadingGrades) {
        <div style="text-align: center; padding: 20px;">
            <mat-spinner diameter="40" style="margin: 0 auto;"></mat-spinner>
            <p>Loading grades...</p>
        </div>
    } @else {
        <label><b>Goaltenders</b></label>
           
        <table style="table-layout: fixed; margin-left: -16px;">
        @for(player of this.getGoalies(); track player.LifelineScoutingId) {
            <tr>
                <td style="max-width: 130px; white-space: nowrap; overflow: hidden; font-size: small;  ">
                    {{player.PlayerView.JerseyNo}} {{player.PlayerView.LastName}}, {{player.PlayerView.FirstName}}
                    <span style="font-size: 9px; color: gray;">[{{getPlayerGrade(player.PlayerView.LifelineScoutingId)}}]</span>
                </td>
                <td style=" white-space: nowrap; overflow: hidden; ">
                     <mat-button-toggle-group class="rating-group rating-compact" hideSingleSelectionIndicator="true" aria-label="Rating" [value]="getPlayerGrade(player.PlayerView.LifelineScoutingId)" (change)="UpdateGamePlayerRating(player.PlayerView.LifelineScoutingId, game.GameId, $event.value)">
                        <mat-button-toggle value="0" class="rating-notselected" style="min-width: 30px; max-width: 30px;" >-</mat-button-toggle>
                        <mat-button-toggle value="1" class="rating-bad">Bad</mat-button-toggle>
                        <mat-button-toggle value="2" class="rating-average">Avg</mat-button-toggle>
                        <mat-button-toggle value="3" class="rating-good">Good</mat-button-toggle>
                        <mat-button-toggle value="4" class="rating-very-good">V Good</mat-button-toggle>
                        <mat-button-toggle value="5" class="rating-excellent">Exc</mat-button-toggle>
                    </mat-button-toggle-group>
                </td>
            </tr>

        }
        </table>
        <mat-divider></mat-divider>
        <label><b>Defenders</b></label>
       
        <table style="table-layout: fixed; margin-left: -16px;">
        @for(player of this.getDefenders(); track player.LifelineScoutingId) {
            <tr>
                <td style="max-width: 130px; white-space: nowrap; overflow: hidden; font-size: small;  ">
                    {{player.PlayerView.JerseyNo}} {{player.PlayerView.LastName}}, {{player.PlayerView.FirstName}}
                </td>
                <td style=" white-space: nowrap; overflow: hidden; ">
                     <mat-button-toggle-group class="rating-group rating-compact" hideSingleSelectionIndicator="true" aria-label="Rating" [value]="getPlayerGrade(player.PlayerView.LifelineScoutingId)" (change)="UpdateGamePlayerRating(player.PlayerView.LifelineScoutingId, game.GameId, $event.value)">
                        <mat-button-toggle value="0" class="rating-notselected" style="min-width: 30px; max-width: 30px;" >-</mat-button-toggle>
                        <mat-button-toggle value="1" class="rating-bad">Bad</mat-button-toggle>
                        <mat-button-toggle value="2" class="rating-average">Avg</mat-button-toggle>
                        <mat-button-toggle value="3" class="rating-good">Good</mat-button-toggle>
                        <mat-button-toggle value="4" class="rating-very-good">V Good</mat-button-toggle>
                        <mat-button-toggle value="5" class="rating-excellent">Exc</mat-button-toggle>
                    </mat-button-toggle-group>
                </td>
            </tr>
        }
        </table>
        <mat-divider></mat-divider>
        <label><b>Forwards</b></label>
    
        <table style="table-layout: fixed; margin-left: -16px;">
        @for(player of this.getForwards(); track player.LifelineScoutingId) {
            <tr>
                <td style="max-width: 130px; white-space: nowrap; overflow: hidden; font-size: small;  ">
                    {{player.PlayerView.JerseyNo}} {{player.PlayerView.LastName}}, {{player.PlayerView.FirstName}}
                </td>
                <td style=" white-space: nowrap; overflow: hidden; ">
                     <mat-button-toggle-group class="rating-group rating-compact" hideSingleSelectionIndicator="true" aria-label="Rating" [value]="getPlayerGrade(player.PlayerView.LifelineScoutingId)" (change)="UpdateGamePlayerRating(player.PlayerView.LifelineScoutingId, game.GameId, $event.value)">
                        <mat-button-toggle value="0" class="rating-notselected" style="min-width: 30px; max-width: 30px;" >-</mat-button-toggle>
                        <mat-button-toggle value="1" class="rating-bad">Bad</mat-button-toggle>
                        <mat-button-toggle value="2" class="rating-average">Avg</mat-button-toggle>
                        <mat-button-toggle value="3" class="rating-good">Good</mat-button-toggle>
                        <mat-button-toggle value="4" class="rating-very-good">V Good</mat-button-toggle>
                        <mat-button-toggle value="5" class="rating-excellent">Exc</mat-button-toggle>
                    </mat-button-toggle-group>
                </td>
            </tr>
        <!-- <div style="display: flex; flex-direction: row; align-items: center; margin-bottom: 5px; justify-content: space-between;">
            <div style="margin-bottom: 2px; white-space: nowrap; max-width: 150px; overflow: hidden; font-size: small;" >{{player.PlayerView.JerseyNo}} {{player.PlayerView.LastName}}, {{player.PlayerView.FirstName}}</div>
            <div style="min-width: 100px;">
            <mat-button-toggle-group class="rating-group rating-compact" hideSingleSelectionIndicator="true" aria-label="Rating" (change)="UpdateGamePlayerRating(player.PlayerView.LifelineScoutingId, game.GameId, $event.value)">
                    <mat-button-toggle value="0" class="rating-notselected" style="min-width: 30px; max-width: 30px;" >-</mat-button-toggle>
                    <mat-button-toggle value="1" class="rating-bad">Bad</mat-button-toggle>
                    <mat-button-toggle value="2" class="rating-average">Avg</mat-button-toggle>
                    <mat-button-toggle value="3" class="rating-good">Good</mat-button-toggle>
                    <mat-button-toggle value="4" class="rating-very-good">V good</mat-button-toggle>
                    <mat-button-toggle value="5" class="rating-excellent">Exc</mat-button-toggle>
                </mat-button-toggle-group>
                </div>
        </div> -->
    }
    </table>
    }
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-raised-button [mat-dialog-close]="true" cdkFocusInitial>CLOSE</button>
    @if(data.CanEdit){
        <button mat-raised-button [mat-dialog-close]="true"  [routerLink]="['/scouting/editreport', data.ReportId]" cdkFocusInitial>EDIT</button>
    }
    
    
</mat-dialog-actions>